/**
 * Reference card for the eight Business Discovery stages. INTERNAL only.
 *
 * Static: it explains the shape of every conversation — wide at the start,
 * narrowing stage by stage to one confirmed problem statement. It shows no
 * session's progress; that is on each Business Discovery's own page.
 */

import { DISCOVERY_LAYERS } from '../config';
import '../styles/DiscoveryPyramid.css';

export default function DiscoveryPyramid() {
  return (
    <section className="nsc-card nsc-stages" aria-labelledby="nsc-stages-title">
      <div className="nsc-card__header">
        <div className="nsc-card__heading">
          <h2 id="nsc-stages-title" className="nsc-card__title">Discovery stages</h2>
          <p className="nsc-card__description">
            Every conversation opens wide and narrows, stage by stage, to one
            confirmed problem statement.
          </p>
        </div>
      </div>
      <ol className="nsc-stages__list">
        {DISCOVERY_LAYERS.map((layer, index) => (
          <li
            key={layer.id}
            className="nsc-stages__item"
            style={{ '--stage-inset': `${index * 2.5}%` }}
          >
            <span className="nsc-stages__code">{layer.id}</span>
            <span className="nsc-stages__label">{layer.label}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
